module.exports = __webpack_public_path__ + "static/media/ICB_BANNER.87c8b974.jpg";